import React from "react";
import { MediaFile } from "src/api/file/file-types";
import { ResizedImage } from "src/components";

import { Swiper, SwiperSlide } from "swiper/react";

type Props = {
  medias: MediaFile[];
  alt: string;
};

const SwiperViewer = ({ medias, alt = "이미지" }: Props) => {
  return (
    <section className={`slider list ${!medias || medias?.length === 0 ? "noImage" : ""}`}>
      <Swiper
        pagination={{
          type: "fraction",
        }}
        parallax={true}
        className="detail-product-swiper"
      >
        {medias?.map((media: MediaFile, index: number) => {
          return (
            <SwiperSlide key={media.id}>
              <div className="slider-bg" data-swiper-parallax={"23%"}>
                <ResizedImage url={media.url} className="slider-bg-img" alt={alt + index} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default SwiperViewer;
